import { useState } from "react";
import { PageShell, usePageMeta } from "@/components/PageShell";
import { PrescriptionQuiz } from "@/components/Quiz";
import { IMAGES } from "@/data/catalog";

export default function FindYourJar() {
  usePageMeta("Find your jar · Dirty Paws Apothecary", "Five quick questions. One recommendation, with the daily measure for your dog's weight.");
  const [done, setDone] = useState(false);
  return (
    <PageShell testid="quiz-page" page={done ? "quiz-result" : "quiz"}>
      <div className="wrap">
        <div className="quiz" style={done ? { display: "block" } : undefined}>
          <div><PrescriptionQuiz onDone={setDone} /></div>
          {!done && (
            <aside className="panel side" data-testid="quiz-what-you-get">
              <img src={IMAGES.field} alt="Three of the founding dogs running down a field path toward the camera" style={{ objectPosition: "50% 60%" }} />
              <div className="eyebrow" style={{ marginBottom: 8 }}>What you'll get</div>
              <ul><li><em>1</em>The jar that fits your dog, or a pairing</li><li><em>2</em>Their daily measure, by weight</li><li><em>3</em>How long a jar lasts them</li></ul>
              <p className="muted" style={{ fontSize: 12.5, marginTop: 14 }}>General guidance, not veterinary advice.</p>
            </aside>
          )}
        </div>
      </div>
    </PageShell>
  );
}
